<template>
  <div v-if="showGreetingCardExtra">
    <ProductGreetingCardExtraV3
      v-for="(greetingCardExtra, i) in greetingCardExtras"
      :key="i"
      :title="greetingCardExtra.title"
      :handle="greetingCardExtra.greetingCardHandle"
      :multiple-selection="
        greetingCardExtra?.tag
          ? greetingCardExtra?.tag?.split('-').at(-1) == 'multiple'
          : false
      "
      :dynamic-price="greetingCardExtra.dynamicPrice"
      :show-no-option="true"
      :show-upsell-table="false"
      @greeting-card-selected="getProductGrettingCardSelected"
    />
  </div>
</template>

<script lang="ts" setup>
import useProductStore from '@/store/product'
import useSettingStore from '@/store/setting'
import { onMounted, watch, computed, ref } from 'vue'
import { isProductHasTags } from '@/utils/product'
import {
  EVENT_UPDATE_GREETING_CARD_EXTRA,
  EVENT_UPDATE_GIFT_BOX_EXTRA,
  HANDLE_PRODUCT_UPSELL_WITH_GREETING_CARD,
} from '@/utils'
import EventBus from '@/services/eventbus'
import ProductGreetingCardExtraV3 from './ProductGreetingCardExtraV3.vue'

const productStore = useProductStore()
const settingStore = useSettingStore()

const productGreetingCardExtras = ref<any[]>([])
const buyGiftBox = ref(false)

const greetingCardExtras = computed(() => {
  if (!settingStore.baseProductPage?.upsellGreetingCard?.length) {
    return []
  }
  return settingStore.baseProductPage?.upsellGreetingCard.filter((item: any) =>
    isProductHasTags(productStore.product, [item?.tag || ''])
  )
})

const showGreetingCardExtra = computed(() => {
  if (!greetingCardExtras.value?.length) return false

  const skuPrefix =
    settingStore.baseProductPage?.skuPrefixHideUpsellGreetingCard?.split(',') ||
    []
  const productSkuPrefix =
    productStore.selectedVariant?.skuPrefix?.toUpperCase()

  const exists = greetingCardExtras.value?.some(
    (item: any) => item?.greetingCardHandle?.includes('ipatugrc00424')
  ) ?? false
  if (skuPrefix.includes(productSkuPrefix) && !exists) {
    EventBus.trigger(EVENT_UPDATE_GREETING_CARD_EXTRA, [])
    return false
  }

  return true
})

onMounted(() => {
  watch(
    () => productGreetingCardExtras.value,
    (val) => {
      const lineItems = val.map((item: any) => ({
        merchandiseId: item.merchandiseId,
        quantity: item.quantity || 1,
        attributes: item.attributes || [],
      }))
      EventBus.trigger(EVENT_UPDATE_GREETING_CARD_EXTRA, lineItems)
    },
    { deep: true }
  )

  watch(() => buyGiftBox.value, (val) => {
    EventBus.trigger(EVENT_UPDATE_GIFT_BOX_EXTRA, val ? { checked: true } : null)
  })
})

function getProductGrettingCardSelected(data: any) {
  productGreetingCardExtras.value = productGreetingCardExtras.value.filter(
    (item: any) => item.productHandle !== data.productHandle
  )

  if (data.greetingCardVariantArrSelected?.length) {
    const selected = data.greetingCardVariantArrSelected.map((variant: any) => ({
      productHandle: data.productHandle,
      merchandiseId: variant.id,
      quantity: 1,
      attributes: [
        {
          key: HANDLE_PRODUCT_UPSELL_WITH_GREETING_CARD,
          value: productStore.product?.handle,
        },
      ],
    }))
    productGreetingCardExtras.value.push(...selected)
  }
}
</script>
